import { Table } from "antd";
import StateTag from "Components/state-tag";
import { CONTRACT_STATUS } from "Constants";
import { createComponentStore } from "easy-peasy";
import React, { useEffect } from "react";
import { ParameterStoreModel } from "store/models/parameters/general-parameter";
import ContractStatusTag from "Pages/private/transactions/contracts/components/status-tag";
import moment from "moment";
import ContractOperations from "./operations-column";
import { STATUS_LOCALIZIED } from "Constants/contract";
import { compareDates } from "Utils";
import Highlighter from "react-highlight-words";

const useContractTypeStore = createComponentStore(
  ParameterStoreModel("contracttypes")
);

const statusFiltersList = () => {
  let filters = [];
  Object.keys(CONTRACT_STATUS).forEach((item) => {
    let d = {
      text: CONTRACT_STATUS[item],
      value: item,
    };
    filters.push(d);
  });
  return filters;
};

const contractTypesFilterList = (contracttypes) => {
  let filters = [];
  if (contracttypes.length > 0) {
    contracttypes.forEach((item) => {
      let d = {
        text: item?.description,
        value: item?.id,
      };
      filters.push(d);
    });
  }
  return filters;
};

export default function ContractsTable({
  IsAuthorized,
  data,
  loading,
  filteredValue,
  onSetFilteredValue,
  onOperationExecuted,
  ...props
}) {
  const [contracttypes, contracttypesActions] = useContractTypeStore();

  useEffect(() => {
    contracttypesActions.fetch();
  }, []);

  const columns = (contracttypes) => {
    return [
      {
        title: "Kod",
        dataIndex: "code",
        key: "code",
        width: 80,
        sorter: (a, b) => {
          return a.code.substr(1) - b.code.substr(1);
        },
      },
      {
        title: "Muhatap",
        dataIndex: ["partner", "name"],
        key: "partner",
        width: 300,
        ellipsis: true,
        sorter: (a, b) => {
          let fullNameA = a.partner.name + " " + a.partner.surname;
          let fullNameB = b.partner.name + " " + b.partner.surname;

          return fullNameA.localeCompare(fullNameB, "tr");
        },
        render: (item, record) => (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[filteredValue.fastSearchParam || ""]}
            autoEscape
            textToHighlight={
              record.partner?.name + "" + " " + (record.partner?.surname + "")
            }
          />
        ),
      },
      {
        title: "Sözleşme Türü",
        dataIndex: ["type", "description"],
        key: "type",
        width: 300,
        ellipsis: true,
        sorter: (a, b) =>
          a.type.description.localeCompare(b.type.description, "tr"),
        filters: contractTypesFilterList(contracttypes),
        onFilter: (value, record) => record.type.id === value,
        render: (item, record) => (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[filteredValue.fastSearchParam || ""]}
            autoEscape
            textToHighlight={record.type?.description + ""}
          />
        ),
      },
      {
        title: "Durum",
        dataIndex: ["contractStatu"],
        key: "statu",
        sorter: (a, b) => {
          return STATUS_LOCALIZIED[a.contractStatu].localeCompare(
            STATUS_LOCALIZIED[b.contractStatu]
          );
        },
        width: 150,
        ellipsis: true,
        render: (item, record) => {
          return (
            <>
              <ContractStatusTag contractStatu={record.contractStatu} />
              <StateTag state={record.state} />
            </>
          );
        },
        filters: statusFiltersList(),
        onFilter: (value, record) => record.contractStatu === value,
      },
      {
        title: "Başlangıç Tarihi",
        dataIndex: "dateOfBeginning",
        key: "dateOfBeginning",
        sorter: (a, b) => compareDates(a.dateOfBeginning, b.dateOfBeginning),
        width: 160,
        ellipsis: true,
        render: (text, record) => {
          return moment(record.dateOfBeginning).format("DD.MM.YYYY");
        },
      },
      {
        title: "Bitiş Tarihi",
        dataIndex: "dateOfFinish",
        key: "dateOfFinish",
        sorter: (a, b) => compareDates(a.dateOfFinish, b.dateOfFinish),
        width: 160,
        ellipsis: true,
        render: (text, record) => {
          if (record.dateOfFinish)
            return moment(record.dateOfFinish).format("DD.MM.YYYY");
        },
      },

      {
        title: "İmzalama Tarihi",
        dataIndex: "dateOfSign",
        key: "dateOfSign",
        width: 160,
        ellipsis: true,
        sorter: (a, b) => compareDates(a.dateOfSign, b.dateOfSign),
        render: (text, record) => {
          if (record.dateOfSign)
            return moment(record.dateOfSign).format("DD.MM.YYYY");
          else return "";
        },
      },
      {
        title: "İşlemler",
        width: 80,
        fixed: "right",
        dataIndex: "operation",
        render: (text, record) => {
          return (
            <ContractOperations
              record={record}
              onOperationExecuted={onOperationExecuted}
            />
          );
        },
      },
    ];
  };

  return (
    <Table
      rowKey={(row) => row.id}
      style={{ margin: "0 24px" }}
      loading={loading}
      locale={{
        filterConfirm: "Filtrele",
        filterReset: "Temizle",
        emptyText: IsAuthorized
          ? "Kayıt Bulunamadı"
          : "Bu işlem için yetkiniz yok. Sistem yöneticiniz ile iletişime geçebilirsiniz.",
      }}
      dataSource={data || []}
      pagination={{
        total: data.length,
        pageSize: 10,
        showTotal: (total, range) => {
          return `Toplam ${total} sonuçtan ${range.join(
            "-"
          )} arası gösteriliyor.`;
        },
      }}
      columns={columns(contracttypes.data)}
      bordered
      size="small"
      bordered
      showSorterTooltip={false}
      scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
    />
  );
}
